export enum CookieKeys {
  UserCountryRedirectionModalSeen = "user_country_redirection_modal_seen",
  AuthCookie = "pos-auth-token",
  AuthRefreshCookie = "pos-refresh-token",
  SSOCookie = "connect.sid",
  UserOrderCreatedSeen = "user_order_created_seen",
}

export const OneYearExpirationTimeInDays = 365;

export const PURCHASE_PRICE_DIGITS_LIMIT = 9;
